export default {
  orderDetail: {
    titleState: {
      title1: 'Purchase Order',
      title2: 'Order Details'
    },
    stepState: {
      step1: 'Order Submitted',
      step2: 'Merchant Confirmation',
      step3: 'Payment Pending',
      step4: 'Merchant Shipping',
      step5: 'Order Cancelled',
      step6: 'Stock Preparation',
      step7: 'Completed',
      step8:'Hour',
      step9:'Minute',
      step10:'Second',
      step11:'Day',
      step12:'Automatic receiving：',
      
    },
    msgState: {
      msg1: 'Remaining Payment',
      msg2: 'Unpaid orders will auto-cancel upon expiration',
      msg3: 'Order No.：',  // Fixed duplicate msg4 key
      msg4: 'Payable after merchant approval. Rejected orders will auto-cancel.',
      msg5: 'Order Amount：',
      msg6: 'Balance Due：',
      msg7: 'Deposit Paid：',
    },
    btnState: {
      btn1: 'Confirm Receipt',
      btn2: 'Cancel Order',
      btn3: 'Confirm Pickup',
      btn4: 'Delete Order',
      btn5: 'Order Details',
      btn6: 'Cancel Order',  // Duplicate intentional?
      btn7: 'Pay Now',
      btn8: 'After-sales Details',
      btn9: 'Request Refund',
      btn10: 'Pay Balance',
      btn11: 'Reorder',
    },
    khxx: {
      khinfo1: 'Customer Information',
      khinfo2: 'Consignee：',  // Merged duplicate keys
      khinfo3: 'Mobile：',
      khinfo4: 'Shipping Address：',
    },
    peisong: {
      psInfo1: 'Delivery Information',
      psInfo2: 'Shipping Address：',
      psInfo3: 'Delivery Method：',
      psInfo4: 'Merchant Delivery',
      psInfo5: 'Customer Pickup',
      psInfo6: 'Carrier：',
      psInfo7: 'Tracking No.：',
      psInfo8: 'Copy Tracking No.',
      psInfo9: 'Delivery Person：',
      psInfo10: 'Vehicle Plate：',
      psInfo11: 'Track Details',
      psInfo12: 'Pickup Point：',
      psInfo13: 'Pickup Contact：',
      psInfo14: 'Contact Number：',
      psInfo15: 'Pickup Address：',
    },
    fukuan: {
      fkInfo1: 'Payment Information',
      fkInfo2: 'Payment Type：',
      fkInfo3: 'Deposit Method：',
      fkInfo4: 'Deposit Paid On：',
      fkInfo5: 'Balance Payment Method：',
      fkInfo6: 'Balance Paid On：',
      fkInfo7: 'Payment Receipt：',
      fkInfo8: 'View Details',
    },
    qxMassage: {
      qxInfo1: 'Cancellation Details',
      qxInfo2: 'Order Amount：',
      qxInfo3: 'Cancelled On：',
      qxInfo4: 'Cancellation Reason：',
    },
    table: {
      setp1: 'Product',
      setp2: 'Specs：',
      setp3: 'Acceptable defect rate ≤ ',
      setp4: '%; For defects between ',
      setp5: '%, compensation applies; For ',
      setp6: '%, price adjustment applies; Above ',
      setp7: '%, reject or negotiate.',
      setp8: 'Inspection Standard',
      setp9: 'Qty',
      setp10: 'Unit Price',
      setp11: 'Subtotal',
      setp12: 'Buyer Note：',
      setp13: 'Total ',
      setp14: ' items',
      setp15: 'Subtotal：',
      setp16: 'Shipping：',
      setp17: 'Order Total：',
    },
    dialogState: {
      dil1: 'Cancel Order',
      dil2: 'Cancelled orders cannot be restored. Coupons forfeited. Paid amounts will be refunded to original payment method after review.',
      dil3: 'Reconsider',
      dil4: 'Submit',
      dil5: 'Order Tracking',
      dil6: 'Carrier：',
      dil7: 'Tracking No.：',
      dil8: 'Payment Receipt',
    },
    confirmState: {
      confirm1: 'Notification',
      confirm2: 'Confirm',
      confirm3: 'Cancel',
      confirm4: 'Cancelled',
      confirm5: 'Confirm product inspection dispute?',
      confirm6: 'Confirm reorder?',
      confirm7: 'Confirm goods received in good condition per inspection standards?',
      confirm8: 'After confirmation, inspection disputes cannot be filed. Proceed?',
      confirm9: 'Receipt Confirmed',
      confirm10: 'Delete this order?',
      confirm11: 'Order deleted!',
      confirm12: 'Copied!',
    },
    rulesMessage: {
      rule1: 'Invoice title required!',
      rule2: 'Invoice title: 2-50 characters',
      rule3: 'Tax ID: 15-20 characters',
      rule4: 'Enter valid tax ID!',
      rule5: 'Registered phone required!',
      rule6: 'Registered address required!',
      rule7: 'Address: 2-50 characters',
      rule8: 'Bank name required!',
      rule9: 'Bank name: 4-10 characters',
      rule10: 'Enter valid bank name!',
      rule11: 'Recipient name required!',
      rule12: 'Recipient name: 2-10 characters',
      rule13: 'Mobile number required!',
      rule14: 'Enter valid 11-digit mobile!',
      rule15: 'Select region!',
      rule16: 'Detailed address required!',
      rule17: 'Address: 4-50 characters',
    }
  }
}